import Vue from 'vue';
const EventBus = new class {
    constructor() {
        this.vue = new Vue();
    }

    fire(event, data = null) {
        this.vue.$emit(event, data);
    }

    dispatch(event, data = null) {
        this.vue.$emit(event, data);
    }

    listen(event, callback) {
        this.vue.$on(event, callback);
    }

    on(event, callback) {
        this.vue.$on(event, callback);
    }

    removeAllListeners() {
        this.vue.$off();
    }
};
export default EventBus;